import { render } from "./KnowledgeCourseAdmin.vue?vue&type=template&id=7374a2c8&scoped=true"
import script from "./KnowledgeCourseAdmin.vue?vue&type=script&lang=js"
export * from "./KnowledgeCourseAdmin.vue?vue&type=script&lang=js"

import "./KnowledgeCourseAdmin.vue?vue&type=style&index=0&id=7374a2c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7374a2c8"]])

export default __exports__